// extracted by mini-css-extract-plugin
export default {"selected_content":"styles_selected_content__gA+uQ"};